import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UserListLookup } from '../../../shared/models/users/user-list-lookup';
import { CourseService } from '../../services/course.service';
import { catchError, of, throwError } from 'rxjs';
import { MessageService } from 'primeng/api';
import { DocumentLibraryConstants } from '../../../../app/document/document-library-constants';
import { EnrollmentFormatsConstants } from '../../constants/sessionEnrollment.constants';
import { SessionAttendeeParticipationConstants } from '../../constants/sessionAttendeeParticipation.constants';

@Component({
  selector: 'app-session-attendees-enroll-modal',
  templateUrl: './session-attendees-enroll-modal.component.html',
  styleUrls: ['./session-attendees-enroll-modal.component.scss'],
})
export class SessionAttendeesEnrollModalComponent {
  showSessionAttendeesEnrollModal: boolean = false;
  usersList: UserListLookup[] = [];
  selectedAttendees: any = [];
  valueField: string = 'name';
  labelField: string = 'name';
  @Output() addSessionAttendeesEvent = new EventEmitter();
  @Input() existingSessionAttendee:any;
  showLoader: boolean = false;
  maxAttendeesConstant= SessionAttendeeParticipationConstants.MaxAttendeesConstantText; 

  constructor(private courseService: CourseService,private messageService : MessageService,){
    
  }

 openSessionAttendeeModal = (sessionId: string) => {
  this.showLoader = true;

  this.courseService.getUsersForSessionAttendeeEnrollement(sessionId).pipe(
    catchError((err) => {
      this.showLoader = false;
      this.showSessionAttendeesEnrollModal = false;
      this.messageService.add({
        severity: DocumentLibraryConstants.Severity_Err,
        summary: EnrollmentFormatsConstants.Technical_Error_On_Session_Attendees,
        sticky: true
      });
      return throwError(() => err);
    })
  )
  .subscribe((users) => {

    // Handling null/undefined/empty users
    if (!Array.isArray(users) || users.length === 0) {
      this.messageService.add({
        severity: DocumentLibraryConstants.Severity_Err,
        summary: EnrollmentFormatsConstants.Technical_Error_On_Session_Attendees,
        sticky: true
      });
      this.showLoader = false;
      return;
    }

    // Ensuring that existing attendees list is always a valid array
    const existingAttendees = Array.isArray(this.existingSessionAttendee)
      ? this.existingSessionAttendee
      : [];

    const updatedUserList = users.filter(
      u => !existingAttendees.some(e => e?.attendee === u?.name)
    );

    this.usersList = updatedUserList;
    this.showLoader = false;
    this.showSessionAttendeesEnrollModal = true;
  });
};

  addSessionAttendees = () => {
    this.addSessionAttendeesEvent.emit();
  };

  closeModal = () => {
    this.selectedAttendees=[];
    this.usersList = [];
    this.showSessionAttendeesEnrollModal = false;
  };

  onAttendeeChange() {
  const limitReached = this.selectedAttendees.length >= 50;

  this.usersList = this.usersList.map(user => {
    const userValue = (user as any)[this.valueField];

    return {
      ...user,
      disabled: limitReached && !this.selectedAttendees.includes(userValue)
    };
  });
}

}
